// src/components/PremiumSuccess/PremiumSuccessMobile.jsx
import { useContext, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import MobileHeader from "./headers/MobileHearder";

export default function PremiumSuccessMobile() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("✅ User arrived on success page (mobile):", currentUser?.uid);
  }, [currentUser]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <MobileHeader
          title={translate("PaymentSuccessTitle")}
          showProfileItem={false}
        />
      </Box>

      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 72, color: "success.main", mb: 2 }}
        />
        <Typography variant="h5" gutterBottom>
          {translate("PaymentSuccessTitle")}
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ mb: 3, color: "text.secondary" }}
        >
          {translate("PaymentSuccessMessage")}
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/app")}
        >
          {translate("GoToDashboard")}
        </Button>
      </Box>
    </Box>
  );
}
